import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { CookieService, CookieOptions } from 'ngx-cookie';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { ONBOARD_CONSTANTS } from './app.constants';
import { environment } from '../environments/environment';
import { HttpClientService } from '@flysas/httputil';
import { Router } from '@angular/router';


declare let $: any;

@Injectable()
export class AppService {
  static appOrigin: string;
  static translate: object;
  static apiBaseURL: string;
  public appLanguage: string;
  public appPOS: string;
  expiredDate: Date;
  wifiConnected = false;
  onboardIpFlag = false;
  activateStatus = false;
  public regexForLocale = /^[a-z]{2}[-][a-z]{2}$/;
  public loginUserName: string;
  public deviceResponse;
  public flightResponse;
  public sessionID: string;
  public context = { 'onb': 'ONB', 'onc': 'ONC' };
  public channel: string;
  public fromPage: string;
  public enableNewHeader: boolean;
  public isCharter: boolean;
  public passengerId: any;
  public ancFullFillment = ONBOARD_CONSTANTS.ANCFULL_FILLMENT;
  public checkOutId: string;
  public isUnconfirmedTicket = false;
  public isGrabitEnable: boolean;

  // Observable string sources
  private loaderListner = new BehaviorSubject<any>(true);
  private loaderListnerWithText = new BehaviorSubject<any>(true);
  private deviceStatusCheckAfterLoginOrLogoutListner = new BehaviorSubject<any>(false);
  private landingCustomerListner = new BehaviorSubject<any>(true);
  private landingCustomerLogoutListner = new BehaviorSubject<any>(false);
  private activateCustomerLogoutListner = new BehaviorSubject<any>(false);
  private disconnectWifiStatusListner = new BehaviorSubject<any>(false);
  private showPnrFromSwitchListner = new BehaviorSubject<any>(false);
  private deviceStatusCheckAfterDisconnectWifiListner = new BehaviorSubject<any>(false);

  // Observable string streams
  loaderObservable = this.loaderListner.asObservable();
  loaderObservableWithText = this.loaderListnerWithText.asObservable();
  deviceStatusCheckAfterLoginOrLogoutObservable = this.deviceStatusCheckAfterLoginOrLogoutListner.asObservable();
  landingCustomerObservable = this.landingCustomerListner.asObservable();
  landingCustomerLogoutObservable = this.landingCustomerLogoutListner.asObservable();
  activateCustomerLogoutObservable = this.activateCustomerLogoutListner.asObservable();
  disconnectWifiStatusObservable = this.disconnectWifiStatusListner.asObservable();
  showPnrFromSwitchObservable = this.showPnrFromSwitchListner.asObservable();
  deviceStatusCheckAfterDisconnectWifiObservable = this.deviceStatusCheckAfterDisconnectWifiListner.asObservable();

  constructor(
    private http: HttpClientService,
    private cookieService: CookieService, private router: Router
  ) { }

  public getApiBaseUrl(): string {
    return AppService.apiBaseURL = environment.apiBaseUrl;
  }

  public getTncBaseUrl(): string {
    let baseUrl = '';
    if (this.appLanguage === 'en') {
      baseUrl = `https://${window.location.hostname}/${this.appLanguage}`;
    } else {
      baseUrl = `https://${window.location.hostname}`;
    }
    return baseUrl;
  }

  public setAppLanguage(locale): void {
    const acceptLanguage: string = this.cookieService.get('_language');
    if (this.regexForLocale.test(locale)) {
      this.appLanguage = locale.split('-')[1];
    } else if (acceptLanguage !== '' && acceptLanguage !== undefined) {
      this.appLanguage = acceptLanguage.toLocaleLowerCase();
    } else {
      this.appLanguage = this.getDefaultLanguage();
    }
    const lang = this.cookieService.get('_language');
    if (lang !== undefined) {
      document.getElementsByTagName('html')[0].setAttribute('lang', lang);
    } else {
      this.cookieService.put('_language', this.appLanguage);
    }
  }

  public setAppPOS(locale): void {
    const pos: string = this.cookieService.get('_country');
    if (this.regexForLocale.test(locale)) {
      this.appPOS = locale.split('-')[0];
    } else if (pos !== '' && pos !== undefined) {
      this.appPOS = pos.toLowerCase();
    } else {
      this.appPOS = this.getDefaultPOS();
    }
    this.enableNewHeader = true;
    const posval = this.cookieService.get('_country');
    if (!posval || posval === undefined) {
      this.cookieService.put('_country', this.appPOS);
    }
  }

  public setOrigin(): void {
    const origin: string = this.cookieService.get('_origin');
    if (origin !== '' && origin !== undefined) {
      AppService.appOrigin = origin.toLowerCase();
    }
  }

  public getLanguage(): string {
    return this.getDefaultLanguage();
  }

  public getDefaultLanguage(): string {
    return ONBOARD_CONSTANTS.LANGUAGE;
  }

  public getPOS(): string {
    const pos: string = this.cookieService.get('_country');
    if (pos !== '' && pos !== undefined) {
      return pos.toLocaleLowerCase();
    } else {
      return this.getDefaultPOS();
    }
  }

  public getDefaultPOS(): string {
    const defaultPOS = ONBOARD_CONSTANTS.POS;
    this.cookieService.put('_country', defaultPOS);
    return defaultPOS;
  }

  setOnboardTranslations(translations) {
    AppService.translate = translations;
  }

  setLoggedInUsername(username) {
    this.loginUserName = username;
  }

  getLoggedInUsername(): string {
    return this.loginUserName;
  }

  getSessionId(): any {
    const sessionId = sessionStorage.getItem('sessionId') ? sessionStorage.getItem('sessionId') : (decodeURIComponent(this.cookieService.get('NEW_SAS_SSO_LOGGEDIN'))).replace('tkt=', '');
    if (sessionId === 'undefined' || !sessionId) {
      return false;
    } else {
      return sessionId;
    }
  }

  public setSessionID(value: string) {
    this.sessionID = value;
  }

  getDeviceToken(): string {
    let deviceToken: string;
    const queryParams = this.getQueryParams();
    const deviceTokenQP = queryParams.get('deviceToken');
    const deviceTokenSS = sessionStorage.getItem('deviceToken');
    const deviceTokenCookie = this.cookieService.get('deviceToken');

    deviceToken = this.checkDeviceToken(deviceTokenQP, deviceTokenSS);
    if (deviceToken && deviceToken !== 'null' && deviceToken !== '') {
      sessionStorage.setItem('deviceToken', deviceToken);
      if (ONBOARD_CONSTANTS.ENABLE_DEVICE_TOKEN_STRIPPING) {
        this.expiredDate = new Date();
        this.expiredDate.setHours(this.expiredDate.getHours() + 2);
        const opts: CookieOptions = {
          expires: this.expiredDate
        };
        this.cookieService.put('deviceToken', deviceToken, opts);
      } else {
        this.cookieService.put('deviceToken', deviceToken);
      }
      this.setDeviceTokenToMenuItem();
      return deviceToken;
    } else if (deviceTokenCookie && deviceTokenCookie !== 'null' && deviceTokenCookie !== '') {
      this.setDeviceTokenToMenuItem();
      sessionStorage.setItem('deviceToken', deviceTokenCookie);
      return deviceTokenCookie;
    } else {
      return deviceToken;
    }
  }

  checkDeviceToken(deviceTokenQP, deviceTokenSS) {
    let deviceToken: string;
    if (deviceTokenQP && deviceTokenQP !== 'null' && deviceTokenQP !== '') {
      deviceToken = this.checkSessionDeviceToken(deviceTokenQP, deviceTokenSS);
    } else if (deviceTokenSS && deviceTokenSS !== 'null' && deviceTokenSS !== '') {
      deviceToken = deviceTokenSS;
    } else {
      deviceToken = 'null';
    }
    return deviceToken;
  }

  checkSessionDeviceToken(deviceTokenQP, deviceTokenSS) {
    let deviceToken: string;
    if (deviceTokenSS && deviceTokenSS !== 'null' && deviceTokenSS !== '') {
      if (deviceTokenQP !== deviceTokenSS) {
        deviceToken = deviceTokenQP;
      } else {
        deviceToken = deviceTokenSS;
      }
    } else {
      deviceToken = deviceTokenQP;
    }
    return deviceToken;
  }

  checkOnboardIpRange() {
    if (ONBOARD_CONSTANTS.ENABLE_IP_CHECK === 'true') {
      const onboardCookieValue = this.cookieService.get('onboard');
      if (onboardCookieValue === 'true') {
        $('#nav-onboard').removeClass('hide');
        $('#header-navigation #nav-onboard').removeClass('hide');
        this.onboardIpFlag = true;
        this.setOnboardMenuActive();
      } else {
        $('#nav-onboard').remove();
        this.onboardIpFlag = false;
      }
    } else {
      this.onboardIpFlag = true;
    }
  }

  getOnboardIpFlag() {
    return this.onboardIpFlag;
  }

  setOnboardVisitedFlag() {
    this.cookieService.put('onboard_visited', 'true');
  }

  setOnboardMenuActive() {
    $('#nav-onboard').addClass('active');
  }

  buyMoreDevices() {
    var buybtn = setTimeout('$("div#btn-buymoredevices").delay(0).hide(0)');
    // var buybtn =  $(this).find('div#btn-buymoredevices').addClass('hide');

  }

  setDeviceTokenToMenuItem() {
    const deviceToken = sessionStorage.getItem('deviceToken');
    if (deviceToken) {
      if (ONBOARD_CONSTANTS.ENABLE_DEVICE_TOKEN_STRIPPING) {
        $('#nav-onboard a').attr('href', '/home');
        //$('#nav-onboard a').attr('href', '/home/voucher');
      } else {
        $('#nav-onboard a').attr('href', '/home?deviceToken=' + deviceToken);
        // $('#nav-onboard a').attr('href', '/home/voucher?deviceToken=' + deviceToken);
      }
    }
  }

  setFlagClassToMarketSelector() {
    $('#market-selector>a.market-selector').addClass('flag-' + this.appPOS.toUpperCase());
  }

  getQueryParams(): URLSearchParams {
    const queryParams = new URLSearchParams(window.location.href.split('?')[1]);
    return queryParams;
  }

  removeScrollBody() {
    $('html').css('overflow-y', 'hidden');
    $('body').css('overflow-y', 'hidden');
    $('body').css('position', 'fixed');
    $('body').css('width', '100%');
  }

  removePositionValue() {
    $('body').css('position', '');
  }

  addScrollBody() {
    $('html').css('overflow-y', 'auto');
    $('body').css('overflow-y', 'hidden');
    $('body').css('position', '');
    $('body').css('width', '');
  }

  removeCustomerErrors() {
    $('#customer-error').hide();
  }

  // To fix IOS issue
  makecursorWorkFine() {
    // Detect ios 11_x_x affected
    // NEED TO BE UPDATED if new versions are affected
    const ua = navigator.userAgent,
      iOS = /iPad|iPhone|iPod/.test(ua),
      iOS11 = /OS 11_0|OS 11_1|OS 11_2/.test(ua);

    // ios 11 bug caret position
    if (iOS && iOS11) {

      // Add CSS class to body
      $('body').addClass('iosBugFixCaret');

    }
  }

  public showCookieBar() {
    if (!this.enableNewHeader) {
      return true;
    } else {
      return false;
    }
  }

  getSessionStorage(parentKey, key) {
    let sessionData = sessionStorage.getItem(parentKey);
    let sessionKeyValue;
    if (sessionData) {
      sessionData = JSON.parse(sessionData);
    }
    if (sessionData && sessionData[key]) {
      sessionKeyValue = sessionData[key];
    }
    return sessionKeyValue;
  }

  public redirectToHomePage() {
    if (ONBOARD_CONSTANTS.ENABLE_DEVICE_TOKEN_STRIPPING) {
      this.router.navigate(['/home']);
    } else {
      this.router.navigate(['/home'], { queryParams: { 'deviceToken': sessionStorage.getItem('deviceToken') } });
    }
  }

  public getHomePageURL(): string {
    if (ONBOARD_CONSTANTS.ENABLE_DEVICE_TOKEN_STRIPPING) {
      return '/home';
    } else {
      return '/home?deviceToken=' + sessionStorage.getItem('deviceToken');
    }
  }

  // Service message commands
  public showLoader() {
    this.loaderListner.next(true);
  }

  public hideLoader() {
    this.loaderListner.next(false);
  }

  public showLoaderWithText(componentTextData) {
    this.removeScrollBody();
    const value = { 'componentState': true, 'componentText': componentTextData };
    this.loaderListnerWithText.next(value);
  }

  public hideLoaderWithText() {
    this.addScrollBody();
    const value = { 'componentState': false, 'componentText': '' };
    this.loaderListnerWithText.next(value);
  }

  public deviceStatusCheckAfterLoginOrLogout() {
    this.deviceStatusCheckAfterLoginOrLogoutListner.next(true);
  }

  public showLandingCustomer() {
    this.landingCustomerListner.next(true);
  }

  public hideLandingCustomer() {
    this.landingCustomerListner.next(false);
  }

  public customerLogoutFromActivate() {
    this.activateCustomerLogoutListner.next(true);
  }

  public customerLogoutFromLanding() {
    this.landingCustomerLogoutListner.next(true);
  }

  public changeDisconnectWifiStatus() {
    this.disconnectWifiStatusListner.next(true);
  }

  public showPnrFromSwitch() {
    this.showPnrFromSwitchListner.next(true);
  }

  public checkDeviceStatusAfterDisconnectWifi() {
    this.deviceStatusCheckAfterDisconnectWifiListner.next(true);
  }
  public setFromPage(page) {
    this.fromPage = page;
  }

  public getFromPage() {
    return this.fromPage;
  }

  public scrollToTop() {
    $(window).scrollTop(0);
  }

  public setScrollTop(selector) {
    setTimeout(function () { $(selector).scrollTop(0); }, 200);
  }

  public scrollToActivateModel() {
    $('#wifi-onboard-connect').scrollTop(0);
  }

  public setActivateStatus(status) {
    this.activateStatus = status;
  }
  public getActivateStatus() {
    return this.activateStatus;
  }

  public setGetDeviceResponse(response) {
    this.deviceResponse = response;
  }

  public getDeviceResponse() {
    return this.deviceResponse;
  }

  public getContext() {
    const isCharter = this.getFlightServiceType();
    let contextType;
    if (isCharter || this.isUnconfirmedTicket) {
      contextType = this.context.onc;
    } else {
      contextType = this.context.onb;
    }

    return contextType;
  }

  public getChannel() {
    const displayWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return this.channel = displayWidth >= 768 ? 'WEB' : 'MOW';
  }

  public getProfileId() {
    return this.cookieService.get('PROFILE_ID') ? this.cookieService.get('PROFILE_ID') : '';
  }

  public setFlightResponse(flightData) {
    this.flightResponse = flightData;
  }

  public getFlightResponse() {
    const filghtData = JSON.parse(sessionStorage.getItem('flightData'));
    if (filghtData && filghtData.flightNumber) {
      this.flightResponse = filghtData;
    }
    return this.flightResponse;
  }

  public getFlightServiceType() {
    if (this.flightResponse.flightType === 'charter') {
      this.isCharter = true;
    } else { this.isCharter = false; }
    return this.isCharter;
  }

  public getLocalizedUrl(url) {
    const regexForLocale = /^[a-z]{2}[-][a-z]{2}$/;
    const regexForLocale2 = /^([a-z]{2})$/;
    const locale = window.location.pathname.split('/')[1];
    let urlValue;
    if (!url.startsWith('/')) {
      url = `/${url}`;
    }

    if (regexForLocale.test(locale) || regexForLocale2.test(locale)) {
      urlValue = `/${locale}${url}`;
    } else {
      urlValue = url;
    }
    return urlValue;
  }

  public setFavicon() {
    const path = `https://${window.location.hostname}` + '/favicon.ico';
    $('#favicon').attr('href', path);
  }

  public setPassengerIdData(passengerId) {
    this.passengerId = passengerId;
  }

  public getPassengerIdData() {
    return this.passengerId;
  }

  public setCheckOutId(checkOutId) {
    this.checkOutId = checkOutId;
  }

  public getCheckOutId() {
    return this.checkOutId;
  }

  public setUnconfirmedTicket(isUnconfirmedTicket: boolean) {
    this.isUnconfirmedTicket = isUnconfirmedTicket;
  }
  public identifyGrabitStatus(flightId, tailId) {
    if (flightId === '*' || tailId === '*') {
      return Boolean(true);
    }
    else {
      const configuredFlightId = flightId.split(',');
      const configuredTailId = tailId.split(',');
      return Boolean(configuredFlightId.indexOf(this.flightResponse.flightNumber) > -1 || configuredTailId.indexOf(this.flightResponse.vehicleId) > -1)
    }
  }
  public loadCustJs(THIS: any, callback?: () => void | any) {
    if (!this.isCustJsLoaded()) {
      const script = document.createElement('script');
      const windowLocation = location.origin;
      script.type = 'text/javascript';
      script.src =
        windowLocation.indexOf('localhost') > -1 || windowLocation.indexOf('test') > -1
          ? 'https://components.test.flysas.com/v1/sasui-customerlib/lib/Customer.min.js'
          : 'https://components.flysas.com/v1/sasui-customerlib/lib/Customer.min.js';
      script.onload = () => {
        if (callback) {
          callback.bind(THIS)();
        }
      };
      document.body.appendChild(script);
    } else {
      if (callback) {
        if ((window as any).Customer) { callback.bind(THIS)(); }
      }
    }
  }
  isCustJsLoaded() {
    const scripts = document.querySelectorAll('script') as any;
    for (const script of scripts) {
      if (script.src.indexOf('Customer.min.js') > -1) {
        return true;
      }
    }
    return null;
  }
}
